<template>
  <v-dialog
    :model-value="modelValue"
    max-width="420"
    @update:model-value="onDialogUpdate"
  >
    <v-card rounded="xl" class="user-dialog-card caller-ids-dialog">
      <div
        class="dialog-header d-flex align-center justify-space-between"
      >
        <div class="d-flex align-center ga-3 min-w-0">
          <div class="caller-ids-dialog__header-icon">
            <v-icon color="primary" size="20">mdi-account-multiple-outline</v-icon>
          </div>
          <span class="dialog-header__title text-truncate">
            Caller IDs{{ dayLabel ? ` · ${dayLabel}` : '' }}
          </span>
        </div>
        <v-btn
          icon
          variant="text"
          size="small"
          rounded="lg"
          aria-label="Close"
          @click="close"
        >
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </div>

      <v-card-text class="dialog-body caller-ids-dialog__body">
        <ul v-if="callerIds.length" class="caller-ids-dialog__list">
          <li
            v-for="(id, index) in callerIds"
            :key="`${id}-${index}`"
            class="caller-ids-dialog__item"
          >
            <v-icon size="16" class="caller-ids-dialog__item-icon"
              >mdi-phone-outline</v-icon
            >
            <span class="caller-ids-dialog__item-text">{{ formatPhone(id) }}</span>
          </li>
        </ul>
        <p v-else class="caller-ids-dialog__empty mb-0">
          No caller IDs for this day.
        </p>
      </v-card-text>

      <v-card-actions class="dialog-footer">
        <v-spacer />
        <v-btn
          variant="text"
          class="text-none dialog-btn dialog-btn--muted"
          rounded="lg"
          @click="close"
        >
          Close
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { formatPhoneNumber } from '@/utils/format'

export default {
  name: 'CallerIdsDialog',
  props: {
    modelValue: {
      type: Boolean,
      default: false,
    },
    dayLabel: {
      type: String,
      default: '',
    },
    callerIds: {
      type: Array,
      default: () => [],
    },
  },
  emits: ['update:modelValue'],
  methods: {
    formatPhone(value) {
      return formatPhoneNumber(value)
    },
    onDialogUpdate(value) {
      this.$emit('update:modelValue', value)
    },
    close() {
      this.$emit('update:modelValue', false)
    },
  },
}
</script>

<style scoped>
.caller-ids-dialog__header-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 36px;
  height: 36px;
  border-radius: 10px;
  background: rgba(99, 102, 241, 0.15);
  flex-shrink: 0;
}

.caller-ids-dialog__body {
  padding: 12px 20px 16px !important;
}

.caller-ids-dialog__list {
  list-style: none;
  margin: 0;
  padding: 0;
  display: flex;
  flex-direction: column;
  gap: 6px;
  max-height: 280px;
  overflow-y: auto;
}

.caller-ids-dialog__item {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 8px 12px;
  border-radius: 10px;
  background: var(--y-glass-surface);
  border: 1px solid var(--y-glass-border);
}

.caller-ids-dialog__item-icon {
  color: #a5b4fc;
  flex-shrink: 0;
}

.caller-ids-dialog__item-text {
  font-size: 0.875rem;
  font-weight: 500;
  color: var(--y-text);
  word-break: break-all;
}

.caller-ids-dialog__empty {
  font-size: 0.8125rem;
  color: var(--y-text-muted);
}
</style>
